import { Button, Icon, Tooltip, TooltipContent, TooltipTrigger } from "@elit-hair/elit-ui";
import { useTranslation } from "react-i18next";
import { IconType } from "react-icons";

type HeaderKpiItemProps = {
    value: string;
    label: string | IconType;
    translation: string;
};

export function HeaderKpiItem({ value, label, translation }: HeaderKpiItemProps) {
    const { t } = useTranslation();

    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <Button
                    variant="outline"
                    size="sm"
                    className="cursor-default hover:bg-muted hover:text-muted-foreground"
                    aria-label={translation}
                >
                    <span className="font-medium">{value}</span>
                    {typeof label === "string" ? (
                        <span className="text-muted-foreground">{label}</span>
                    ) : (
                        <Icon icon={label} className="text-muted-foreground" />
                    )}
                </Button>
            </TooltipTrigger>
            <TooltipContent side="bottom" sideOffset={5}>
                {t(translation)}
            </TooltipContent>
        </Tooltip>
    );
}
